import React from 'react';
import { motion } from 'framer-motion';
import { eventBus } from '@/utils/eventBus';

const Hero = () => {
  return (
    <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Premium Background Image */}
      <div className="absolute inset-0 z-0">
        <motion.img
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 10, ease: "easeOut" }}
          src="/images/hero_sueti.avif"
          alt="Luxury Travel Landscape"
          className="w-full h-full object-cover object-center"
        />
        {/* Sophisticated Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/40 to-slate-900/80"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 z-10 relative text-center mt-16">
        <div className="max-w-4xl mx-auto flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="flex flex-col items-center"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-accent"></div>
              <span className="text-accent font-medium tracking-[0.3em] uppercase text-xs md:text-sm">
                Eksklusif & Terpercaya
              </span>
              <div className="w-12 h-px bg-accent"></div>
            </div>

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-white mb-8 leading-tight drop-shadow-2xl">
              Perjalanan <br className="hidden md:block" />
              <span className="italic font-light text-white/90">Penuh Makna</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-200 mb-12 max-w-2xl font-light leading-relaxed">
              Merangkai kenangan indah melintasi benua dan meraih kekhusyukan di Tanah Suci dengan standar pelayanan kelas dunia.
            </p>

            <div className="flex flex-col sm:flex-row gap-6">
              <button
                onClick={() => eventBus.dispatch('openBookingModal', { service: 'Lainnya' })}
                className="bg-accent hover:bg-accent-dark text-white px-10 py-4 rounded-sm font-medium tracking-wider uppercase text-sm transition-all duration-300 shadow-lg shadow-accent/20 border border-accent cursor-pointer"
              >
                Mulai Rencana Anda
              </button>
              <a
                href="#services"
                className="bg-transparent hover:bg-white/10 text-white border border-white/50 backdrop-blur-sm px-10 py-4 rounded-sm font-medium tracking-wider uppercase text-sm transition-all duration-300"
              >
                Eksplorasi Layanan
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-12 bg-white/20 relative overflow-hidden">
          <motion.div
            animate={{ y: [0, 48, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            className="w-full h-1/2 bg-accent absolute top-0"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;